import { gsap } from 'gsap';
import { AdditiveBlending, Mesh } from 'three';
import { computed, ref, watchEffect } from 'vue';

import { lerp, map } from '@resn/gozer-math';
import { simplePlaneGeometry } from '@resn/gozer-three';
import { CustomMaterial } from '@resn/gozer-three/materials';
import { basePaneOptions, usePane, useRafBool, useThreeObject } from '@resn/gozer-vue';

export const useRipWipe = (shader) => {
    const active = ref(false);

    let playInterval;
    let playDelay;
    let tl;
    const tweens = { highlightPr: 0, inPr: 0 };

    const highlightPr = ref(0);
    const ripHightlightColor = ref('#829cd2');
    const highlightBaseColor = ref('#2b3d6e');
    const ripXOffset = ref(0.86);
    const highlightFeather = ref(0.1);

    const startInterval = () => {
        stopInterval();

        gsap.killTweensOf(tweens, 'inPr');
        gsap.to(tweens, { inPr: 1, duration: 1.5, ease: 'sine.inOut', onUpdate: setProgress });

        playDelay = gsap.delayedCall(1, () => {
            playAnimation();

            playInterval = setInterval(() => {
                playAnimation();
            }, 4000);
        });
    };

    const stopInterval = () => {
        playDelay?.kill();
        clearInterval(playInterval);

        // gsap.killTweensOf(tweens, 'inPr');
        // gsap.to(tweens, { inPr: 0, duration: 0.5, ease: 'sine.in', onUpdate: setProgress });
    };

    const setProgress = () => {
        shader.uniforms.highlightPr.value = tweens.highlightPr;
        shader.uniforms.inPr.value = tweens.inPr;
    };

    const complete = () => {
        tl?.kill();
        stopInterval();
    };

    const playAnimation = () => {
        tl?.kill();
        tl = gsap.timeline({
            onStart: () => (active.value = true),
            onComplete: () => (active.value = false),
            onUpdate: setProgress,
        });

        tl.fromTo(
            tweens,
            {
                highlightPr: 0,
            },
            {
                highlightPr: 1,
                duration: 2,
                ease: 'sine.inOut',
            }
        );
    };

    watchEffect(() => {
        shader.uniforms.highlightPr.value = highlightPr.value;
        shader.uniforms.ripHightlightColor.value.set(ripHightlightColor.value);
        shader.uniforms.highlightBaseColor.value.set(highlightBaseColor.value);
        shader.uniforms.ripXOffset.value = ripXOffset.value;
        shader.uniforms.highlightFeather.value = highlightFeather.value;
    });

    const pane = usePane(
        [
            { name: 'highlightPr', value: highlightPr, options: basePaneOptions },
            { name: 'ripHightlightColor', value: ripHightlightColor },
            { name: 'highlightBaseColor', value: highlightBaseColor },
            { name: 'ripXOffset', value: ripXOffset, options: { min: 0.5, max: 1, step: 0.001 } },
            {
                name: 'highlightFeather',
                value: highlightFeather,
                options: { min: 0, max: 0.25, step: 0.001 },
            },
        ],
        {
            title: 'RipWipe',
        }
    );

    // useRafBool(active, ({ timestamp }) => {
    //     material.uTime = timestamp * 0.001;
    //     material.uIntensity = intensity.value;
    //     material.uRotationSpeed = rotationSpeed.value;
    //     material.uRayFreq = rayFreq.value;
    //     material.uRaySpeed = raySpeed.value;
    //     material.uStreakWidth = streakWidth.value;
    //     material.uStreakLength = streakLength.value;
    //     material.uProgress = progress.value;

    //     bgMaterial.uIntensity = bgIntensity.value;
    // });

    return {
        startInterval,
        stopInterval,
        setProgress,
        complete,
    };
};
